'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgViewOff(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M10.33.54a.818.818 0 111.158 1.157l-9.819 9.818a.818.818 0 11-1.157-1.157zm.75 3.879c.38.485.69 1.026.92 1.608a6.451 6.451 0 01-6.593 4.064zM6 1.936c.2 0 .398.01.593.027L.92 7.636A6.463 6.463 0 010 6.027a6.451 6.451 0 016-4.09z", id: "View-off_svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#View-off_svg__a" })))));
}

module.exports = SvgViewOff;
//# sourceMappingURL=ViewOff.js.map
